const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

/**
 * Poll `fetchTier` until it returns "pro" or `timeoutMs` elapses. Fetch errors
 * are swallowed (webhook latency, transient network) — we just poll again.
 * Returns true if pro was observed, false on timeout.
 */
export async function pollUntilPro(
  fetchTier: () => Promise<string>,
  { intervalMs = 2000, timeoutMs = 30000 }: { intervalMs?: number; timeoutMs?: number } = {},
): Promise<boolean> {
  const deadline = Date.now() + timeoutMs;
  for (;;) {
    try {
      if ((await fetchTier()) === "pro") return true;
    } catch {
      // transient — keep polling until the deadline
    }
    if (Date.now() + intervalMs > deadline) return false;
    await sleep(intervalMs);
  }
}
